import { render, staticRenderFns } from "./SkuBatchSetting.vue?vue&type=template&id=7e8c00a4&scoped=true"
import script from "./SkuBatchSetting.vue?vue&type=script&lang=js"
export * from "./SkuBatchSetting.vue?vue&type=script&lang=js"
import style0 from "./SkuBatchSetting.vue?vue&type=style&index=0&id=7e8c00a4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e8c00a4",
  null
  
)

export default component.exports